import React from "react"

import { lineNameFor, roundNumber } from '../../helpers'
import { COST_CATEGORIES, defaultCostCategoryFor } from "./category_styles"

const parseNum = v => {
  const n = parseFloat(String(v ?? "").replace(",", "."))
  return Number.isFinite(n) ? n : 0
}

export default class CostCategory extends React.Component {
  onChange(e) {
    const { index, replaceLine, qline, overheadCoefs, overheadCoef, saleCoefOverrides } = this.props
    const value = e.target.value
    const next  = { ...qline, cost_category: value }
    if (value === "labor") next.unit = "h"

    // Auto-application of the coefficients applied to the quote for this
    // cost category: PV = PA × (1 + overhead coef) × sale coef. The overhead
    // coef is resolved via overheadCoefs (quote override takes priority, otherwise
    // account); the sale coef comes from the quote overrides (if there
    // is none, we don't touch the PV — the user is free to
    // enter it manually).
    const pa = parseNum(qline.purchase_price)
    if (pa > 0) {
      const fg = (overheadCoefs && overheadCoefs[value] != null)
                   ? parseNum(overheadCoefs[value])
                   : parseNum(overheadCoef)
      const venteOverride = saleCoefOverrides && saleCoefOverrides[value]
      if (venteOverride != null && venteOverride !== "") {
        const vente = parseNum(venteOverride)
        if (vente > 0) {
          next.unit_price = roundNumber(pa * (1 + fg) * vente)
        }
      }
    }

    replaceLine(next, index)
  }

  render() {
    const { qline, index, enabledCategories } = this.props
    const value      = qline.cost_category || defaultCostCategoryFor(qline.type) || "other"
    const baseList   = (Array.isArray(enabledCategories) && enabledCategories.length > 0) ? enabledCategories : COST_CATEGORIES
    const categories = baseList.includes(value) || !COST_CATEGORIES.includes(value)
                         ? baseList
                         : [...baseList, value]

    return (
      <React.Fragment>
        <label htmlFor={`cost-category-${index}`}>
          {I18n.t("quotes.new.cost_category.label")}
        </label>

        <select
          id        = {`cost-category-${index}`}
          className = "form-control h-41px"
          value     = {value}
          onChange  = {this.onChange.bind(this)}
          name      = {lineNameFor("cost_category", index)}
        >
          { categories.map(category =>
            <option key={category} value={category}>
              {I18n.t(`quotes.new.cost_category.${category}`)}
            </option>
          )}
        </select>
      </React.Fragment>
    )
  }
}
